/**
 * Define variables so they could be easily accessible through both JavaScript and
 * Sass, availability in Sass through 'sass-vars-loader', where exported objects can
 * be accessed through map-get() sass function.
 *
 * Example usage in scss-file(s):
 *
 *  .some-style {
 *    color: map-get($colors, darkBlue1);
 *    background-color: map-get($colors, semiWhite);
 *  }
 *
 *  $some-variable: map-get($colors: lightBlue1);
 *
 */
const lightThemeColors = require('@prisjakt/design-tokens/light-theme-colors');
const measurements = require('@prisjakt/design-tokens/measurements');

const colors = {
  white: lightThemeColors.base0,
  semiWhite: lightThemeColors.base100,
  darkBlue1: lightThemeColors.base700,
  darkBlue2: lightThemeColors.base700,
  darkBlue3: lightThemeColors.base700,
  lightBlue1: lightThemeColors.maybeBlue700,
  lightBlue2: lightThemeColors.maybeBlue700,
  lightBlue3: lightThemeColors.maybeBlue700,
  lightBlue4: lightThemeColors.maybeBlue300,
  green1: lightThemeColors.positive500,
  green2: lightThemeColors.positive500,
  green3: lightThemeColors.positive700,
  green4: lightThemeColors.positive300,
  darkGreen1: lightThemeColors.positive700,
  lightGray1: lightThemeColors.base200,
  lightGray2: lightThemeColors.base300,
  mediumGray1: lightThemeColors.base400,
  mediumGray2: lightThemeColors.base500,
  darkGray1: lightThemeColors.base500,
  darkGray2: lightThemeColors.base500,
  darkGray3: lightThemeColors.base600,
  darkGray4: lightThemeColors.base600,
  yellow1: lightThemeColors.yellove700,
  yellow2: lightThemeColors.yellove700,
  yellow3: lightThemeColors.yellove700,
  yellow4: lightThemeColors.yellove900,
  yellow5: lightThemeColors.notice300,
  red1: lightThemeColors.negative700,
  red2: lightThemeColors.negative700,
  red3: lightThemeColors.negative700,
  red4: lightThemeColors.negative300,
  maybeBlue500: lightThemeColors.maybeBlue500,
};

const campaignColors = {
  blackFriday: {
    id: 2,
    background: '#000',
    text: lightThemeColors.base0,
  },
  christmasSale: {
    id: 3,
    background: '#B70016',
    text: lightThemeColors.base0,
  },
  dailyDeals: {
    id: 4,
    background: '#9B051A',
    text: lightThemeColors.base0,
  },
  cyberMonday: {
    id: 6,
    background: '#5AA546',
    text: lightThemeColors.base0,
  },
  blackFridayWeekend: {
    id: 7,
    background: '#000',
    text: lightThemeColors.base0,
  },
  januarySale: {
    id: 12,
    background: '#4895B6',
    text: lightThemeColors.base0,
  },
};

const brandColors = {
  twitter: '#00ACED',
  facebook: '#3B5998',
  pricespy: '#4895B6',
  expert: lightThemeColors.maybeBlue500,
};

const ratingStarColors = {
  inactive: lightThemeColors.base300,
  active: lightThemeColors.yellove500,
};

const layout = {
  headerHeightDesktop: '70px',
};

module.exports = {
  colors,
  campaignColors,
  brandColors,
  ratingStarColors,
  layout,
  measurements,
};
